import { render, staticRenderFns } from "./SetupMFA.vue?vue&type=template&id=537a9922&scoped=true"
import script from "./SetupMFA.vue?vue&type=script&lang=ts"
export * from "./SetupMFA.vue?vue&type=script&lang=ts"
import style0 from "./SetupMFA.vue?vue&type=style&index=0&id=537a9922&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a9922",
  null
  
)

export default component.exports